import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Product } from '@df/catalog/product/product';
import { Wishlist } from '@df/session/api/wishlist/wishlist';

@Injectable({
    providedIn: 'root'
})
/**
 * @deprecated Use wishlistLoadResolver instead
 */
export class WishlistLoadResolver implements Resolve<void> {
    constructor(private wishlit: Wishlist) {}

    resolve(): Promise<void> {
        return this.wishlit.load();
    }
}

export const wishlistLoadResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    await inject(Wishlist).load();
};
